<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="primary",
      absolute,
      top
    )
    v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
      v-col.py-0.text-right
        v-btn(color="white", @click="save", :disabled="loading") {{$t('Common.save')}}
    v-row(v-if="!loading")
      v-col.py-0
        v-card.elevation-24.mb-5(style="overflow: visible")
          app-full-entity(:entity="entityWithCustomRelation", v-bind="{ customLabel }")
            template(v-slot:DocumentRequest="props")
              .general
                .entity-content.pa-5
                  v-row
                    v-col.d-flex.align-center
                      h2.primary--text {{$tc('DocumentRequest._name', 1)}}
                  v-row(align="end")
                    v-col.pt-0
                      v-text-field(
                        :label="$t('DocumentRequest.name')",
                        v-model="instance.name",
                        :error-messages="errors['documentRequest.name']"
                      )
                    v-col.pt-0
                      v-text-field(
                        :label="$t('DocumentRequest.label')",
                        v-model="instance.label"
                        :error-messages="errors['documentRequest.label']"
                      )
                    v-col.pt-0
                      .selector(fluid)
                        b {{$t('DocumentRequest.applicableOn')}}
                        v-radio-group(v-model='instance.applicableOn', row, @change="SetApplicableEntity")
                          v-radio(label='Orders' value='Order')
                          v-radio(label='Shipments' value='Shipment')
                  v-row
                    v-col
                      app-datetime-picker(
                        :value="instance.createdAt",
                        :label="$t('DocumentRequest.createdAt')",
                        disabled,
                      )
                    v-col
                      app-datetime-picker(
                        :value="instance.modifiedAt",
                        :label="$t('DocumentRequest.modifiedAt')",
                        disabled,
                      )
                    v-col
                      v-text-field(
                        :label="$t('DocumentRequest.user')",
                        :value="(instance.user || {}).fullName"
                        :error-messages="errors['documentRequest.user']",
                        :error="!!errors['documentRequest.user']",
                        disabled,
                      )
                  v-row
                    v-col.d-flex.align-center
                      h2.primary--text {{$t('DocumentRequest.allowedFormats')}}
                  v-row(justify="space-around")
                    v-checkbox.mx-2(v-model='checkedFormats' label='.txt', value='.txt')
                    v-checkbox.mx-2(v-model='checkedFormats' label='.doc', value='.doc')
                    v-checkbox.mx-2(v-model='checkedFormats' label='.docx', value='.docx')
                    v-checkbox.mx-2(v-model='checkedFormats' label='.csv', value='.csv')
                    v-checkbox.mx-2(v-model='checkedFormats' label='.xls', value='.xls')
                    v-checkbox.mx-2(v-model='checkedFormats' label='.xlsx', value='.xlsx')
                    v-checkbox.mx-2(v-model='checkedFormats' label='.ppt', value='.ppt')
                    v-checkbox.mx-2(v-model='checkedFormats' label='.pptx', value='.pptx')
                    v-checkbox.mx-2(v-model='checkedFormats' label='.pdf', value='.pdf')
                    v-checkbox.mx-2(v-model='checkedFormats' label='.jpg', value='.jpg')
                    v-checkbox.mx-2(v-model='checkedFormats' label='.png', value='.png')
                    v-checkbox.mx-2(v-model='checkedFormats' label='.zpl', value='.zpl')
                    v-checkbox.mx-2(v-model='checkedFormats' label='.zpl2', value='.zpl2')
              template(v-for="section in (props.sections || []).filter(x => x.section === entity.name || x.section === entity.tabLabel)")
                app-entity-relation(:path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)", :vertical="section.type !== 'BusinessScope'")
</template>


<style lang="sass">
.delete-button
  position: absolute
  right: 15px
</style>

<script>
import { assign } from "lodash/assign";
import axios from "axios";
import { mapGetters } from "vuex";
import EntityMixin from '@/mixins'

export default {
  name: "entity-add",
  mixins: [EntityMixin],
  data: function() {
    return {
      loading: true,
      extraFields: [],
      errors: {},
      checkedFormats: [],
      tabsOrder: ['businessScope', 'rulesToRequest', 'rulesToRequired'],
    };
  },
  computed: {
    //Get the current entity with its relation for the full entity
    entityWithCustomRelation () {
      const entityCopy = _.cloneDeep(this.entity);
      const toSections = { rulesToRequest: 'DocumentRequest', rulesToRequired: 'DocumentRequest' };
      let newFields = this.$sectionedFields(entityCopy, toSections);
      entityCopy.fields = this.$sortFields(newFields, this.tabsOrder);

      return entityCopy;
    },
    // Get the name of the current entity
    entityName() {
      return "DocumentRequest";
    },
    //Get the entity as object
    entity() {
      return this.$searchEntity(this.entityName, "name");
    },
    //Get the current uid depending on route params
    uid() {
      return this.$route.params.item;
    },
    customLabel() {
      return ({
        DocumentRequest: this.$t('Common.general'),
        rulesToRequest: this.$t('DocumentRequest.rulesToRequest'),
        rulesToRequired: this.$t('DocumentRequest.rulesToRequired'),
      });
    },
  },
  methods: {
    //Set environment variable "entityForCriteria" for DocumentRequest, with the entity selected on Applicable On field
    SetApplicableEntity(entity) {
      ENV.ENTITIES['DocumentRequest'].entityForCriteria = entity;
    },
    // Send the POST action in order to save the captured data of the entity
    async save() {
      this.loading = true;
      try {
        this.instance.allowedFormats = JSON.stringify(this.checkedFormats);
        this.instance = (await axios.post("entity/graph", this.instance)).data;
        this.$router.push({
          name: "entities.index",
          params: { entity: this.entity.name }
        });
      } catch (error) {
        this.errors = error.response.data.errors;
      }
      this.loading = false;
    },
    // If the entity has Uid, load the specific entity, else load default values for Document Request
    async load() {
      ({ data: { data: this.businessScopes } } = await axios.get('BusinessScopes', { params: { pageSize: -1 } }));
      if (this.uid) {
        try {
          this.instance.uid = this.uid;
          this.instance = {
            ...this.instance,
            ...(
              await axios.get(`${this.entity.name}/${this.uid}?load[]=User`, {
                _Entity: this.entity.name,
                uid: this.uid
              })
            ).data
          };
          this.checkedFormats = JSON.parse(this.instance.allowedFormats);
          this.SetApplicableEntity(this.instance.applicableOn)
          this.instance.entityState = ENV.ENTITY.STATE.MODIFIED;
        } catch (error) {
          console.error(error);
        }
      }
      this.loading = false;
    },
    async getBusinessScope(businessScopeId){
      if(businessScopeId == null) return null;
      let bs = (await axios.get('BusinessScope?where[]=id=' + businessScopeId)).data.data;
      return bs[0];
    },
  },
  //Actions to do when the fisrt time this component is loaded
  async created() {
    const lsbusinessScopeId = window.localStorage.getItem("BusinessScopeId");
    const lsbusinessScope = await this.getBusinessScope(lsbusinessScopeId);

    this.$store.commit('SET_INSTANCE', { entityState: 4,
                                        _Entity: this.entity.name,
                                        user: this.$store.state.user.user,
                                        businessScope: lsbusinessScope,
                                        requestDocumentType: 'ByCriteria',
                                        requireDocumentType: 'ByCriteria',
                                        applicableOn: 'Order',
                                        })
    await this.load()
  },
};
</script>
